import { createUseStyles } from '@glu/theming';

const styles = ({ indicators }) => ({
  root: {
    borderRadius: 100,
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-start',
    backgroundColor: ({ backgroundColor }) => backgroundColor || indicators.backgroundColor,
    height: ({ height }) => height
  }
});

export default createUseStyles(styles);
